import { render, staticRenderFns } from "./WordmapLoader.vue?vue&type=template&id=346912aa&"
import script from "./WordmapLoader.vue?vue&type=script&lang=js&"
export * from "./WordmapLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports